import * as React from 'react';

export const Icon = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3989 20.9451C9.9157 20.6586 9.22883 20.4578 8.49968 20.7703C7.40919 21.2377 5.07798 22.0036 4.04869 22.3282L2.21266 20.4921C3.71487 17.5619 7.56497 11.5234 10.9477 10.8113C12.8238 10.4163 14.0393 10.7618 14.7832 11.3076C15.6363 10.3175 16.6397 9.23612 17.8186 8.05721C26.7923 -0.916388 33.398 2.73509 33.398 2.73509C33.398 2.73509 36.7011 8.99224 27.8329 18.0719C26.6639 19.2409 25.5908 20.2373 24.6075 21.0858C25.2888 21.7841 25.8114 23.0673 25.3579 25.2214C24.6458 28.6041 18.6073 32.4542 15.677 33.9564L13.841 32.1204C14.1656 31.0911 14.9315 28.7599 15.3989 27.6694C15.7367 26.8812 15.4747 26.1424 15.1529 25.6568C15.0927 25.6302 15.0641 25.6108 15.0641 25.6108L10.3989 20.9451ZM10.1787 31.8545C8.54943 33.4837 2 34 2 34C2 34 2.64938 27.5837 4.27864 25.9544C5.90789 24.3252 8.54943 24.3252 10.1787 25.9544C11.8079 27.5837 11.8079 30.2252 10.1787 31.8545ZM22.1002 13.4484C23.3139 14.6622 25.2818 14.6622 26.4955 13.4484C27.7092 12.2347 27.7092 10.2669 26.4955 9.05312C25.2818 7.83939 23.3139 7.83939 22.1002 9.05312C20.8865 10.2669 20.8865 12.2347 22.1002 13.4484Z"
      fill="url(#paint0_linear_26734_39077)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_26734_39077"
        x1="18"
        y1="2.11765"
        x2="18"
        y2="33.8824"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7E00" stopOpacity="0.58" />
        <stop offset="1" stopColor="#FF7E00" />
      </linearGradient>
    </defs>
  </svg>
);
